import { colors } from '@alixpartners/ui-components';

export const FONT_STYLE = {
	fontSize: '11px',
	fontWeight: '400',
	lineHeight: '13px',
	letterSpacing: 0,
	color: colors.grey7,
};

export const PAGE_SIZE = 15;
